import { render, staticRenderFns } from "./RemarkModal.vue?vue&type=template&id=4af2a36e"
import script from "./RemarkModal.vue?vue&type=script&lang=js"
export * from "./RemarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af2a36e')) {
      api.createRecord('4af2a36e', component.options)
    } else {
      api.reload('4af2a36e', component.options)
    }
    module.hot.accept("./RemarkModal.vue?vue&type=template&id=4af2a36e", function () {
      api.rerender('4af2a36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/RemarkModal.vue"
export default component.exports